import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import WhatsApp from'./Assets/Projects/WhatsApp.svg';

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);
  const openWhatsApp = () => {
    const url = `https://wa.me/${+201000943383}`;
    window.open(url, "_blank");
  };
  return (
    <Router>
      <Preloader load={load} />
<div className=""style={{position:"absolute",bottom:10,right:85,zIndex: 100000000,backgroundColor:"red"}}>
<button
      onClick={openWhatsApp}
      style={{
        position: "fixed",
        bottom: "20px",
        backgroundColor: "#25D366",
        color: "white",
        border: "none",
        padding: "10px 12px",
        borderRadius: "50%",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
      }}
    >
      <img src={WhatsApp}alt='WhatsApp'
      style={{
        width:"40px"
      }}
      />
    </button>
</div>
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />

        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
